// item types
export const JOBCASTS = "Position";
export const CANDIDATES = "RecruiterSubmission";
export const AGENCIES = "Individual";
